export default "__VITE_ASSET__FaCukFNs__"